module.exports = __webpack_public_path__ + "static/img/2.a29787e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/2.png
// module id = iLqE
// module chunks = 0